import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { toast } from "sonner";

const FavCtx = createContext(null);

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState([]); // list of {breed_id, breed, added_at}
  const [ids, setIds] = useState(new Set());

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/me/favorites`);
      setFavorites(r.data);
      setIds(new Set(r.data.map((f) => f.breed_id)));
    } catch {
      setFavorites([]); setIds(new Set());
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (breed) => {
    const id = breed.id;
    try {
      if (ids.has(id)) {
        await axios.delete(`${API}/me/favorites/${id}`);
        toast(`Removed ${breed.name}`);
      } else {
        await axios.post(`${API}/me/favorites/${id}`, {});
        toast.success(`Saved ${breed.name}`);
      }
      refresh();
    } catch {
      toast.error("Couldn't save — try again");
    }
  };

  return (
    <FavCtx.Provider value={{ favorites, ids, toggle, refresh }}>
      {children}
    </FavCtx.Provider>
  );
}

export const useFavorites = () => useContext(FavCtx);
